import React from 'react';
import { Link } from 'react-router-dom';

const tabs = [
  ['documents', 'Documents', 'folder_open'],
  ['sizing', 'Size Finder', 'square_foot'],
];

export default function ResourceTabs({ active, onChange, t, showBuyingPower = false }) {
  const select = (key, container) => {
    onChange(key);
    container?.querySelector(`#rc-tab-${key}`)?.focus();
  };

  return (
    <div className={showBuyingPower ? 'rc-navigation' : undefined}>
      <div
        className="rc-tabs"
        role="tablist"
        aria-label={t('Resources & Tools')}
        onKeyDown={(event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next =
            event.key === 'Home'
              ? 'documents'
              : event.key === 'End'
                ? 'sizing'
                : active === 'documents'
                  ? 'sizing'
                  : 'documents';
          select(next, event.currentTarget);
        }}
      >
        {tabs.map(([key, label, icon]) => (
          <button
            key={key}
            type="button"
            role="tab"
            tabIndex={active === key ? 0 : -1}
            aria-selected={active === key}
            aria-controls={`rc-panel-${key}`}
            id={`rc-tab-${key}`}
            onClick={() => onChange(key)}
          >
            <span className="material-symbols-outlined" aria-hidden="true">
              {icon}
            </span>
            {t(label)}
          </button>
        ))}
      </div>
      {showBuyingPower && (
        <Link className="rc-bank-shortcut" to="/distributor/bank#buying-power-calculator">
          <span className="material-symbols-outlined" aria-hidden="true">
            calculate
          </span>
          {t('Bank calculator')}
          <span className="material-symbols-outlined" aria-hidden="true">
            arrow_forward
          </span>
        </Link>
      )}
    </div>
  );
}

export function ResourceStateTabs({ state, onChange, t }) {
  return (
    <div className="rc-state-tabs" aria-label={t('Document state')}>
      {[
        ['all', 'All'],
        ['published', 'Published'],
        ['draft', 'Drafts'],
        ['archived', 'Archived'],
      ].map(([key, label]) => (
        <button key={key} type="button" aria-pressed={state === key} onClick={() => onChange(key)}>
          {t(label)}
        </button>
      ))}
    </div>
  );
}
